import z from 'zod';
import { createStrictSchema } from '../../lib/util/zod-helpers.js';
import { MovementInfoIdSchema, MovementInfoSchema } from '../movement/movement.types.js';
import { MuscleInfoIdSchema, MuscleInfoSchema } from '../muscle/muscle.types.js';
import { muscleRoleInMovements } from './movement-muscle.constants.js';
const MovementMuscleTableSelectSchema = createStrictSchema()({
    movementId: MovementInfoIdSchema,
    muscleId: MuscleInfoIdSchema,
    role: z.enum(muscleRoleInMovements),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().nullable(),
});
// ===== PUBLIC SCHEMAS (to be used by outer layers) =====
const MovementMuscleInfoSchema = MovementMuscleTableSelectSchema.omit({
    createdAt: true,
    deletedAt: true,
}).extend({
    updatedAt: z.string(), // ISO date string for API
});
const MovementMuscleInfoIdSchema = z.object({
    movementId: MovementInfoIdSchema,
    muscleId: MuscleInfoIdSchema,
});
// @todo: these don't belong here. maybe move in a .constants file.
const MusclesByRoleSchema = z.object({
    primary: z.array(MuscleInfoSchema),
    secondary: z.array(MuscleInfoSchema),
    stabilizer: z.array(MuscleInfoSchema),
});
const MovementWithMusclesInfoSchema = MovementInfoSchema.extend({
    muscles: MusclesByRoleSchema,
});
function groupMusclesByRole(rows) {
    const accumulator = {
        primary: [],
        secondary: [],
        stabilizer: [],
    };
    rows.forEach(({ role, muscle }) => {
        accumulator[role].push(muscle);
    });
    return accumulator;
}
export { MovementMuscleInfoIdSchema, MovementMuscleInfoSchema, MovementMuscleTableSelectSchema, MusclesByRoleSchema, MovementWithMusclesInfoSchema, groupMusclesByRole, };
//# sourceMappingURL=movement-muscle.types.js.map